import React from "react"
import {
    Button,
    componentStyles,
    Box,
    ButtonPrimary,
} from "@mallardbay/lib-react-components"

import COPY from "~config/copy-constants"
import { BUTTON_TYPES } from "~config/constants"

interface Props {
    readonly submitButtonLabel?: string
    readonly cancelButtonLabel?: string
    readonly onSubmit?: () => void
    readonly onCancel?: () => void
    readonly isLoading?: boolean
    readonly isDisabled?: boolean
    readonly showCancelButton?: boolean
    readonly showSubmitButton?: boolean
    readonly isFormSubmit?: boolean
}

export default function ModalButtons({
    submitButtonLabel = COPY.SAVE,
    cancelButtonLabel = COPY.CANCEL,
    onSubmit,
    onCancel,
    isLoading = false,
    isDisabled,
    showCancelButton = true,
    showSubmitButton = true,
    isFormSubmit,
}: Props) {
    const styles = useStyles({ showCancelButton, showSubmitButton })

    return (
        <Box style={styles.root}>
            {showCancelButton && (
                <Button onClick={onCancel} isDisabled={isLoading}>
                    {cancelButtonLabel}
                </Button>
            )}

            {showSubmitButton && (
                <ButtonPrimary
                    onClick={onSubmit}
                    isLoading={isLoading}
                    isDisabled={isDisabled}
                    type={
                        isFormSubmit ? BUTTON_TYPES.SUBMIT : BUTTON_TYPES.BUTTON
                    }
                >
                    {submitButtonLabel}
                </ButtonPrimary>
            )}
        </Box>
    )
}

function useStyles({
    showCancelButton,
    showSubmitButton,
}: {
    showCancelButton: boolean
    showSubmitButton: boolean
}) {
    const justifyContent = getJustifyContent({
        showCancelButton,
        showSubmitButton,
    })

    return componentStyles({
        root: {
            display: "flex",
            justifyContent,
            marginTop: "32px",
        },
    })
}

function getJustifyContent({
    showCancelButton,
    showSubmitButton,
}: {
    showCancelButton: boolean
    showSubmitButton: boolean
}) {
    const isShowingBothButtons = showCancelButton && showSubmitButton

    if (isShowingBothButtons) return "space-between"

    return showCancelButton ? "flex-start" : "flex-end"
}
